import Component from "../core/Component"
import { EMITS as GALLERYGRID_EMITS } from "./GalleryGrid"
import {EMITS as MENU_EMITS} from './Menu'

export const STATES = {
    READY: "is-ready"
}
export const EMITS = {}

export default class Gallery extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            menu: null,
            galleryGrid: null,
            indicator: null
        }

        this.menu = null
        this.index = null
        this.galleryGrid = null
        this.ignoreScroll = true
        this.ignoreScrollTimer = null
        this.initializedWithHash = false
    }

    prepare() {
        this.galleryGrid = Component.getFromElement(this.ref.galleryGrid)
        this.galleryGrid.on(GALLERYGRID_EMITS.SCROLL_CATEGORY_CHANGE, this.handleGridCategoryChange)

        this.menu = Component.getFromElement(this.ref.menu)
        this.menu.on(MENU_EMITS.LINK_CLICKED, this.handleLinkClick)

        const index = this.getInitialIndex()

        setTimeout(() => {
            if (this.initializedWithHash) {
                this.select(index)
            } else {
                this.select(index, false)
            }
        }, 0)

        this.element.classList.add(STATES.READY)
    }

    handleGridCategoryChange = data => {
        if (!this.ignoreScroll) {
            return
        }

        const index = data.index

        this.index = index
        this.updateMenu()
    }

    handleLinkClick = data => {
        const index = data.index

        this.select(index)
    }

    select(index, useScrolling = true) {
        if (this.index === index) {
            return
        }

        this.index = index
        this.updateMenu()

        this.activateScrollIgnoreTimer()

        this.galleryGrid.select(index, useScrolling)
    }

    activateScrollIgnoreTimer() {
        clearTimeout(this.ignoreScrollTimer)

        this.ignoreScroll = false

        this.ignoreScrollTimer = setTimeout(() => {
            this.ignoreScroll = true
        }, 500)
    }

    getInitialIndex() {
        const url = window.location.href
        const anchor = url.substring(url.indexOf("#"))
        const links = this.menu.getLinks()

        let index = links.findIndex(link => link.hash === anchor)

        if (!~index) {
            index = this.menu.getActiveLinkIndex()
        } else {
            this.initializedWithHash = true
        }

        if (index < 0) {
            index = 0
        }

        return index
    }

    updateMenu() {
        this.menu.select(this.index)
        this.updateIndicator()
    }

    updateIndicator() {
        const activeLinkRect = this.menu.getLinks()[this.index].parentNode.getBoundingClientRect()
        const offsetParent = this.ref.indicator.offsetParent

        if (!offsetParent) {
            return
        }

        const elementRect = offsetParent.getBoundingClientRect()

        const top = activeLinkRect.top - elementRect.top
        const height = activeLinkRect.height

        this.ref.indicator.style.top = `${top}px`
        this.ref.indicator.style.height = `${height}px`
    }
}
